import { usePage } from "@inertiajs/react";
import Container from "hardcover-ui/components/Container";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import BookLayout from "features/books/layouts/BookLayout/BookLayout";
import BookEditions from "features/books/components/BookEditions";
import Pagination from "components/shared/Pagination";
import { BookEditionsPageProps } from "./index.props";
import BookEditionControls from "features/books/components/BookEditionControls";

function EditionsIndex() {
  const { book, editions, controlOptions } = usePage<BookEditionsPageProps>().props;
  return (
    <BookLayout>
      <Container variant="layout" size="md">
        <BookEditionControls book={book} controlOptions={controlOptions} />
        <BookEditions book={book} editions={editions} />
        <Pagination />
      </Container>
    </BookLayout>
  );
}

EditionsIndex.layout = DefaultLayoutWrapper;
export default EditionsIndex;